import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HelperService } from '../helper/helper.service';
import { TxService } from '../shared/tx.service';
import { localStorageKeys } from '../localStorage/localStorageVariables';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'content-type': 'application/json',
    }),
  };

  // tslint:disable-next-line: max-line-length
  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private envService: TxService
  ) {
    this.initApiParams();
  }

  initApiParams() {
    this.apiParams = {
      perpage: 10,
    };
  }

  public get sendOtpApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.sendOtpApi = `${this.envService.sendOtpApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set sendOtpApi(value: string) {}

  public get verifyOtpApi(): string {
    const finalRequestParams = {
      ...this.envService.getDefaultApiParams(),
      ...this.apiParams,
    };
    // tslint:disable-next-line: max-line-length
    return (this.verifyOtpApi = `${this.envService.verifyOtpApi()}?${this.helperService.serializeToGetParams(
      finalRequestParams
    )}`);
  }

  public set verifyOtpApi(value: string) {}

  public sendOtp(mobnum: number, callingcode: any): Observable<any> {
    this.apiParams.mobnum = mobnum;
    this.apiParams.callingcode = callingcode;
    return this.httpClient.get(this.sendOtpApi);
  }
  public verifyOtp(
    mobnum: number,
    callingcode: any,
    msgId: string,
    otpId: number,
    otp: number
  ): Observable<any> {
    this.apiParams.mobnum = mobnum;
    this.apiParams.callingcode = callingcode;
    this.apiParams.msgId = msgId;
    this.apiParams.otpId = otpId;
    this.apiParams.otp = otp;
    return this.httpClient.get(this.verifyOtpApi);
  }

  // In AuthService
  transferGuestToken(): void {
    try {
      const token = localStorage.getItem(localStorageKeys.TOKEN);
      if (token) {
        localStorage.setItem(localStorageKeys.GUEST_TOKEN, token);
        localStorage.removeItem(localStorageKeys.TOKEN);
      }
    } catch (error) {
      console.error('Error managing tokens:', error);
    }
  }

  checkIfGuestUser() {
    const userInfoRaw = localStorage.getItem(localStorageKeys.USER_INFO);

    let userInfo: { email?: string; name?: string } = {};

    try {
      userInfo = userInfoRaw
        ? (JSON.parse(userInfoRaw) as { email?: string; name?: string })
        : {};
    } catch {
      userInfo = {};
    }

    return !(
      localStorage.getItem('pno') ||
      userInfo.email?.trim() ||
      userInfo.name?.trim()
    );
  }
}
